import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "stripe",
  "name": "Stripe",
  "category": "integrations",
  "description": "Process payments and manage subscriptions with Stripe",
  "icon": "siStripe",
  "iconType": "simple-icon",
  "color": "purple",
  "version": "1.2.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Stripe",
    "color": "#635bff"
  },
  "credentials": [
    {
      "name": "stripeApi",
      "required": true,
      "displayName": "Stripe API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "stripe",
    "payment",
    "subscription",
    "billing",
    "checkout"
  ],
  "comingSoon": true
};

export default definition;
